import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-beta",
  "use": "foquz-icon-vue-beta-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-beta\"><path d=\"M3.999 6.005a2 2 0 102-2c.583-.211 1-.852 1-1.505a1.5 1.5 0 10-3 0v3.505zm0 0V9\" stroke=\"#339943\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol